import React from 'react';
import { Container } from 'react-bootstrap';

const Notfound = () => {
    return (
        <Container>
            <h2 className="text-danger text-cener">page not found!404</h2>
        </Container>
    );
};

export default Notfound;